{
  "about": {
    "paragraph": "Mes esame įsipareigoję spręsti AGEC įstatymo iššūkius ir informuoti savo klientus apie mūsų produktų kilmę ir aplinkos kokybę.",
    "title": "Apie"
  },
  "lastUpdate": "Paskutinio atnaujinimo data: ",
  "loading": {
    "dataPending": "šiuo metu renka šią informaciją",
    "pendingLocation": "Laukiama vietos"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Drabužių gamyba",
    "FOOTWEAR_FINISHING": "Batų apdaila",
    "FOOTWEAR_STITCHING": "Batų siuvimas",
    "FOOTWEAR_ASSEMBLING": "Batų surinkimas",
    "FABRIC_WEAVING_OR_KNITTING": "Audinių audimas arba mezgimas",
    "FABRIC_DYEING_PRINTING": "Audinių dažymas arba spausdinimas",
    "YARN_PROVIDER": "Siūlų tiekėjas",
    "YARN_DYEING_PRINTING": "Siūlų dažymas arba spausdinimas",
    "LEATHER_TANNING": "Odos odintas",
    "LEATHER_DYEING_PRINTING": "Odos dažymas arba spausdinimas",
    "ACCESSORY_PROVIDER": "Aksesuarų tiekėjas",
    "YARN_MATERIAL_PRODUCTION": "Siūlų medžiagų gamyba",
    "FABRIC_SPINNING": "Audinių verpimas",
    "FABRIC_MATERIAL_PRODUCTION": "Audinių medžiagų gamyba",
    "LEATHER_MATERIAL_PRODUCTION": "Odos medžiagų gamyba",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Aksesuarų žaliavų tiekėjas",
    "COATING": "Dengimas"
  },
  "other": {
    "microplastics_bold": "išskiria mikroplastiką ",
    "paragraph1": "Šis produktas turi ",
    "paragraph1_100": "Šis produktas turi 100% perdirbtų medžiagų.",
    "paragraph2_1": "Šis produktas ",
    "paragraph2_2": "  į aplinką plovimo metu: ",
    "paragraph2_3": "pagal masę produktas sudarytas iš sintetinių pluoštų.",
    "paragraph3": "Informacija apie pavojingų medžiagų galimą buvimą taikyme: ",
    "recycled_matertials_bold": "bent {{percent}}% perdirbtų medžiagų.",
    "recycled_matertials_bold_50": "daugiau nei 50% ",
    "title": "Kitos aplinkos kokybės ir savybės"
  },
  "packaging": {
    "recyclable": "Perdirbamas: Pakuotė yra perdirbama.",
    "recycled": "Perdirbtos medžiagos: Pakuotėje yra bent {{percent}}% perdirbtų medžiagų.",
    "recycled_100": "Perdirbtos medžiagos: Pakuotėje yra 100% perdirbtų medžiagų.",
    "title": "Pakuotės aplinkos kokybės ir savybės"
  },
  "title": "Produkto lapas apie aplinkos kokybę ar charakteristikas",
  "traceability": {
    "paragraph": "Tai reiškia jūsų produkto kilmę pirmuose trijuose gamybos etapuose, nuo jo sukūrimo iki pagrindinės medžiagos audimo ir dažymo.",
    "title": "Produkto sekamumas"
  },
  "ecoScore": {
    "title": "EkoReitingas"
  }
}
